import React from 'react'
import { Button } from './Buttons'
import './Break.css';
import '../App.css';
import { useTypewriter, Cursor } from 'react-simple-typewriter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


function Break() {


    return (
        <div className='break-container'>

            <video src="../Images/SiteHart.mp4" autoPlay loop muted />

        </div>
    )
}

export default Break